'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n  height: 120px;\n  overflow: hidden;\n  margin: 10px;\n  padding: 5px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  color: ', ';\n  word-break: break-all;\n  user-select: none;\n'], ['\n  width: 120px;\n  min-width: 120px;\n  max-width: 120px;\n  height: 120px;\n  overflow: hidden;\n  margin: 10px;\n  padding: 5px;\n  cursor: pointer;\n  text-align: center;\n  font-size: 12px;\n  color: ', ';\n  word-break: break-all;\n  user-select: none;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  font-size: 40px !important;\n  color: ', ';\n  margin-bottom: 10px;\n  margin-top: 20px;\n'], ['\n  font-size: 40px !important;\n  color: ', ';\n  margin-bottom: 10px;\n  margin-top: 20px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('../../Icon/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _colors = require('../../../libs/colors');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Components
// Colors
// Helpers


var Container = _styledComponents2.default.div(_templateObject, _colors.darkGrey);

var FolderIcon = (0, _styledComponents2.default)(_Icon2.default)(_templateObject2, _colors.blue);

var Folder = function Folder(_ref) {
  var text = _ref.text,
      onOpen = _ref.onOpen;
  return _react2.default.createElement(Container, {
    onDoubleClick: onOpen
  }, _react2.default.createElement(FolderIcon, {
    icon: 'folder1'
  }), _react2.default.createElement('br', null), text);
};

Folder.propTypes = {
  text: _propTypes2.default.string,
  onOpen: _propTypes2.default.func
};
exports.default = Folder;